import React, { useState } from "react";
import { fileUrl } from "../lib/api";

/**
 * A photo thumbnail that opens in-app instead of linking to the raw file.
 *
 * Linking straight to the stored file (target="_blank") hands rendering to the
 * browser, which shows the image at its native size — roughly 6x zoom on a phone,
 * so you land in the middle of the picture. This keeps the viewer inside the app
 * where object-contain guarantees the whole photo fits the screen.
 *
 * Self-contained on purpose: it owns its own state, so dropping it into a parent
 * adds no hooks there.
 */
export default function PhotoOpen({ photo, className = "", children, testid }) {
  const [open, setOpen] = useState(false);
  const isVideo = photo?.media_type === "video" || (photo?.content_type || "").startsWith("video/");
  // Fall back to `_fallbackUrl` (ClickUp mirrored) when no local `path` exists.
  const src = photo?.path
    ? fileUrl(photo.path)
    : (photo?._fallbackUrl || photo?.url || "");
  return (
    <>
      <button type="button" className={className} onClick={() => setOpen(true)}
        data-testid={testid || "photo-open"}>
        {children}
      </button>
      {open && (
        <div className="fixed inset-0 z-[70] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setOpen(false)} data-testid="photo-viewer">
          {isVideo ? (
            <video src={src} controls autoPlay playsInline
              className="max-w-full max-h-full" onClick={e => e.stopPropagation()}/>
          ) : (
            <img src={src} alt=""
              className="max-w-full max-h-full object-contain" onClick={e => e.stopPropagation()}/>
          )}
          <button type="button" onClick={() => setOpen(false)} aria-label="Close"
            className="absolute top-4 right-4 h-10 w-10 bg-white border-2 border-[#0f172a] font-black text-lg leading-none">x</button>
        </div>
      )}
    </>
  );
}
